<template>
  <div class="course-list">
    <ul>
      <li
        v-for="item in courseList"
        :key="item.id"
        @click="$router.push(`/course/detail/${item.id}`)"
      >
        <div
          class="course-box"
          :style="{ backgroundImage: `url(${item.pic})` }"
          courseList
        >
          <div class="container">
            <div class="content">
              <h3>{{ item.name }}</h3>
              <h4>{{ item.subtitle }}</h4>
            </div>
            <span>{{ item.salesVolume ? item.salesVolume+item.virtualSales : item.virtualSales || 0}}人已购</span>
          </div>
        </div>
      </li>
    </ul>
    <div class="loading" v-if="!isCourseListEnd">
      <img src="/images/goods/topic3.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data () {
    return {
      courseList: [],
      pageData: {
        pageSize: 20,
        pageNo: 1
      },
      isCourseListEnd: false,
      isLoadingMore: false
    }
  },
  mounted () {
    //初始化会执行一次
    let box = document.querySelector('.loading')
    let observer = new IntersectionObserver(entries => {
      entries.forEach(item => {
        if (item.isIntersecting) {
          this.loadData()
        }
      })
    })
    observer.observe(box)
  },

  methods: {
    loadData () {
      if (this.isLoadingMore) return
      this.isLoadingMore = true
      this.$api
        .payment_v1_goods_offline_course_list_get({
          params: {
            isSale: 1,
            ...this.pageData
          }
        })
        .then(e => {
          if (e) {
            this.courseList = this.courseList.concat(e.content)
            this.pageData.pageNo++
            if (this.courseList.length == e.total) {
              this.isCourseListEnd = true
            }
          } else {
            this.isCourseListEnd = true
          }
        })
        .finally(e => {
          this.isLoadingMore = false
        })
    }
  },

  destroyed(){
    sessionStorage.removeItem("courseExchangeShow");
  }
}
</script>

<style scoped>
.course-list {
  height: 100vh;
  width: 100vw;
}

.course-list ul {
  padding: 26px 11px 2px;
}

.course-list ul li {
  padding-bottom: 16px;
}

.course-box {
  width: 355px;
  height: 200px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 355px;
  height: 96px;
  background: linear-gradient(
    360deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(117, 117, 117, 0) 100%
  );
  border-radius: 0px 0px 8px 8px;
  opacity: 0.8;
  position: absolute;
  left: 0;
  bottom: 0;
}

.content {
  width: 240px;
}

h3 {
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  line-height: 19px;
  padding-left: 16px;
  overflow: hidden;
  /*超出部分隐藏*/
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
  white-space: nowrap;
  /*规定段落中的文本不进行换行 */
}

h4 {
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  line-height: 16px;
  padding-left: 16px;
  margin: 5px 0 9px;
  overflow: hidden;
  /*超出部分隐藏*/
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
  white-space: nowrap;
  /*规定段落中的文本不进行换行 */
}

.course-box span {
  display: block;
  width: 100px;
  height: 49px;
  background: rgba(130, 182, 214, 0.6);
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  line-height: 49px;
  text-align: center;
  flex: 0 0 auto;
}

.loading {
  text-align: center;
  vertical-align: middle;
  padding: 0 0 16px;
}

.loading img {
  width: 24px;
  -webkit-animation: haha1 0.8s linear infinite;
}

@-webkit-keyframes haha1 {
  0% {
    -webkit-transform: rotate(0deg);
  }

  25% {
    -webkit-transform: rotate(90deg);
  }

  50% {
    -webkit-transform: rotate(180deg);
  }

  75% {
    -webkit-transform: rotate(270deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
